import { getBrand } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getBrand";
import { useBrandStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/BrandStore";
import { useQuery as useBrandQuery } from "@faire/web-api--source/endpoints/www/api/brand/brandToken/get-hooks";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";

export const useFaireDirectBrandForVisitorQuery = (
  faireDirectBrandToken: string | undefined,
  isFaireDirectActiveForVisitor: boolean
): IBrand | undefined => {
  const { prefetchedFullBrand } = useBrandStore(["prefetchedFullBrand"]);
  const { data: faireDirectBrand } = useBrandQuery(
    faireDirectBrandToken ?? "",
    undefined,
    {
      enabled: isFaireDirectActiveForVisitor && !!faireDirectBrandToken,
      initialData: () => {
        if (getBrand()?.token === faireDirectBrandToken) {
          return getBrand();
        }

        if (prefetchedFullBrand?.token === faireDirectBrandToken) {
          return prefetchedFullBrand;
        }

        return undefined;
      },
      staleTime: 1000 * 60 * 5,
      refetchOnMount: false,
    }
  );
  return faireDirectBrand;
};
